import { useQuery } from "@tanstack/react-query";
import httpClient from "helpers/hybridHttpClient";
import type { GetServerSidePropsContext } from "next";

import type { StudyProgramEnriched } from "types/studyProgram";

export const fetchCourseContent = async (
  courseSlug: string,
  ctx?: GetServerSidePropsContext,
) => {
  const { data } = await httpClient(ctx).get<StudyProgramEnriched[]>(
    `/api/courses-user/study-programs/course/${courseSlug}/`,
  );
  return data;
};

export const useCourseContent = (courseSlug: string) => {
  return useQuery({
    queryKey: ["courseContent", courseSlug],
    queryFn: () => fetchCourseContent(courseSlug),
  });
};
